  /**
   * Convierte un archivo a base64 (solo contenido, sin encabezado MIME)
   */
export const fileToBase64 = (file: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = () => {
        const arrayBuffer = reader.result as ArrayBuffer;
        const uint8Array = new Uint8Array(arrayBuffer);
        const binaryString = Array.from(uint8Array)
          .map((byte) => String.fromCharCode(byte))
          .join('');
        const base64String = btoa(binaryString);
        resolve(base64String);
      };
      reader.onerror = (event) => {
        const errorMessage = `Error al cargar el archivo: ${event?.target?.error?.message}`;
        reject(new Error(errorMessage));
      };
    });
  };

  /**
   * Convierte un archivo a base64 con encabezado MIME (Data URL)
   */  
export const fileToBase64DataUrl = (file: Blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (event) => {
        const errorMessage = `Error al cargar el archivo: ${event?.target?.error?.message}`;
        reject(new Error(errorMessage));
      };
    });
  };